var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",class:_vm.classes,style:({ width: _vm.calculatedPercent + '%' }),attrs:{"role":"progressbar"}},[_vm._v(_vm._s(_vm.calculatedLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }